import dayjs from "dayjs";
import logo from "../../picshotLogo.jpg";
import { EventType } from "../../types";
import { addMinutes, durationLabel } from "../../utils/date";

export function EventSummary({ event, selectedDate, selectedTime }: { event: EventType; selectedDate: string; selectedTime: string }) {
  return (
    <aside className="event-info">
      <div className="event-info-top">
        <a href="/" className="round-back" aria-label="Back">
          ←
        </a>
        <img src={logo} alt="PicShot" />
      </div>
      <div className="event-info-body">
        <p>PicShot Self Portrait Studio</p>
        <h1>{event.title}</h1>
        <span>◷ {durationLabel(event.durationMinutes)}</span>
        <span>⌖ Баянгол дүүрэг модны 2 ын дунд зам дагуу World mongolia tower 3 давхарт 308 тоот</span>
        {selectedDate && selectedTime && (
          <span>▣ {selectedTime} - {addMinutes(selectedTime, event.durationMinutes)}, {dayjs(selectedDate).format("dddd, MMMM D, YYYY")}</span>
        )}
        <span>◉ Ulaanbaatar Time</span>
        <p className="event-description">{event.description}</p>
      </div>
    </aside>
  );
}
